/**
 * Mobile Portfolio tab list helper. Desktop uses the sidebar Tools link instead.
 */
export function getPortfolioTabs(user, baseTabs) {
  if (!user?.superuser) return baseTabs;
  if (baseTabs.some((t) => t.id === 'backtest')) return baseTabs;
  return [...baseTabs, { id: 'backtest', label: 'Backtest' }];
}
